import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AuthState, LoginPayload, UIError} from 'common/interfaces';
import {IUser} from 'common/interfaces/iuser';

const initialAuthState = {
  loading: false,
  otpRequested: false,
  usernameUpdated: false,
  loggedInUser: null,
  loginPayload: {},
  error: null,
  passwordResetDone: false,
} as AuthState;

const reducers = {
  setLoading: (state: AuthState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: AuthState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
    state.loading = false;
  },
  setRquestOtpError: (
    state: AuthState,
    action: PayloadAction<UIError | null>,
  ) => {
    state.requestOtpError = action.payload;
    state.loading = false;
  },
  setLoggedInUser: (state: AuthState, action: PayloadAction<IUser | null>) => {
    state.loggedInUser = action.payload;
  },
  setOtpRequested: (state: AuthState, action: PayloadAction<LoginPayload>) => {
    state.otpRequested =
      action.payload && action.payload.username ? true : false;
    state.loginPayload = action.payload;
    state.loading = false;
  },
  setLoginPayload: (state: AuthState, action: PayloadAction<LoginPayload>) => {
    state.loginPayload = action.payload;
  },
  setPasswordResetDone: (state: AuthState, action: PayloadAction<boolean>) => {
    state.passwordResetDone = action.payload;
  },
};

const authSlice = createSlice({
  name: 'authState',
  initialState: initialAuthState,
  reducers: reducers,
});

export default authSlice.reducer;
export const AuthActions = authSlice.actions;
